import mutations from './homeSnapshotsMutations'
import isValidSnapshot from './homeSnapshotsValidations'

const getters = {
  validSnapshot: (state, getters, rootState, rootGetters) => key => {
    const snapshot = state[key]

    if (!isValidSnapshot(snapshot, rootGetters.organizationId, rootGetters.accountId)) {
      return null
    }

    return snapshot
  },
}

export default {
  namespaced: true,
  state: () => ({
    toDo: null,
    routines: null,
    activityBoard: null,
  }),
  getters,
  mutations,
}
